import React from 'react';
import LegalPage from './LegalPage';

export default function CookiePolicy() {
  return (
    <LegalPage title="Cookie Policy" lastUpdated="July 2026">
      
      <h2>1. What Are Cookies?</h2>
      <p>
        Like most premium digital platforms, Bombay Coding Company utilizes "cookies"—small text files securely downloaded to your device—to drive the fundamental architecture of our website, enhance user experience, and analyze application performance. 
        This policy explicitly outlines the cookies our React frontend utilizes and how they interact with our infrastructure.
      </p>

      <h2>2. Categories of Cookies We Set</h2>
      <p>
        We strictly partition our cookie usage into minimal, high-utility categories, avoiding bloated third-party trackers where possible:
      </p>
      <ul>
        <li>
          <strong>Strictly Essential Cookies:</strong> These represent the core networking tokens required for the website to function. This includes routing parameters, load-balancing sessions, and security verification strings. The platform cannot function optimally without these, and they do not store personally identifiable intelligence.
        </li>
        <li>
          <strong>Functional Form State Cookies:</strong> When you engage with our contact pipelines, we may store temporary session states via `react-hook-form` to ensure your data is rarely lost in the event of an accidental refresh or network disruption before successful submission.
        </li>
        <li>
          <strong>Performance & Analytics Cookies:</strong> In order to provide our cinematic UI effectively, we utilize strict aggregated analytics to monitor Web Vitals (FCP, LCP, CLS). These cookies anonymously track user flows to help our engineers debug layout shifts and optimize rendering speeds across different operating systems.
        </li>
      </ul>

      <h2>3. Third-Party Integration Cookies</h2>
      <p>
        In some specific integration cases, we rely on trusted third-party frameworks that may inject their own managed cookies:
      </p>
      <ul>
        <li><strong>Google Analytics / Vercel Web Analytics:</strong> Used strictly to monitor anonymous aggregated demographic and performance data to inform our UI/UX updates.</li>
        <li><strong>Application Simulators:</strong> If you utilize our interactive Portfolio case study simulators (such as the LMS viewer or the Gemini sandbox), temporary sandbox tokens may be cached in your local session storage to maintain the state of the isolated demonstration.</li>
      </ul>

      <h2>4. Complete Control & Disabling Cookies</h2>
      <p>
        You retain full administrative control over cookie execution. You can instruct your browser to refuse all non-essential scripts and cookies through your browser's global settings (refer to your respective browser's <em>Security & Privacy</em> documentation).
      </p>
      <p>
        <strong>Warning:</strong> Be aware that aggressively disabling essential cookies will immediately break core routing logic, form submission states, and complex UI animations across our platform. It is strongly recommended to leave default functional cookies enabled for the intended premium experience.
      </p>

    </LegalPage>
  );
}
